export const DEFAULT_SITE_DESIGN_NAMES = [
  'Cloud Launch Studio',
  'Cyber Night Ops',
  'Server Stats Showcase',
  'Growth Agency',
  'Global Cloud Network',
  'SecureCore Enterprise',
  'Isometric Workspace',
  'Network Operations',
  'Performance Growth',
  'Minimal Cloud',
];

export const DEFAULT_SITE_DESIGN_THEMES = [
  'radial-gradient(ellipse at 82% 18%, #1d4ed8 0%, #172554 36%, #020617 78%)',
  'radial-gradient(ellipse at 50% 0%, #164e63 0%, #0f172a 48%, #020617 84%)',
  'radial-gradient(ellipse at 80% 10%, #0e7490 0%, #164e63 30%, #082f49 55%, #020617 90%)',
  'radial-gradient(ellipse at 50% 0%, #6d28d9 0%, #312e81 38%, #0f172a 72%, #020617 100%)',
  'radial-gradient(ellipse at 78% 12%, #0369a1 0%, #164e63 36%, #0f172a 70%, #020617 100%)',
  'radial-gradient(ellipse at 76% 18%, #166534 0%, #14532d 27%, #0f172a 62%, #020617 100%)',
  'radial-gradient(ellipse at 78% 10%, #7c3aed 0%, #4338ca 34%, #172554 67%, #020617 100%)',
  'radial-gradient(ellipse at 76% 18%, #0f766e 0%, #134e4a 34%, #0f172a 68%, #020617 100%)',
  'radial-gradient(ellipse at 80% 12%, #b45309 0%, #9a3412 28%, #431407 52%, #020617 100%)',
  'radial-gradient(ellipse at 80% 16%, #475569 0%, #334155 30%, #1e293b 57%, #020617 100%)',
];

export const createSiteTemplatePage = (templateIndex, library, sharedContent) => {
  const sectionList = (Array.isArray(library) ? library : [])
    .filter(section => section.enabled !== false && !section.deleted)
    .flatMap((definition, order) => {
      const variants = (definition.variants || []).filter(name =>
        !(definition.disabledVariants || []).includes(name)
      );
      if (!variants.length) return [];

      const content = sharedContent[definition.type] || {};
      return [{
        id: `admin-sec-${definition.type}-page-${templateIndex + 1}`,
        type: definition.type,
        name: definition.name,
        variant: variants[(templateIndex + order) % variants.length],
        visible: true,
        order,
        navigation: content.navigation || [],
        actions: content.actions || [],
        heading: content.heading || '',
        subtext: content.subtext || '',
        primaryText: content.primaryText || '',
        secondaryText: content.secondaryText || '',
        kicker: content.kicker || '',
        mediaUrl: content.mediaUrl || '',
        mediaAlt: content.mediaAlt || '',
        cards: content.cards || [],
        styles: definition.type === 'hero'
          ? { section: { backgroundImage: DEFAULT_SITE_DESIGN_THEMES[templateIndex % DEFAULT_SITE_DESIGN_THEMES.length] } }
          : {},
      }];
    });

  return {
    name: DEFAULT_SITE_DESIGN_NAMES[templateIndex] || `Site ${templateIndex + 1}`,
    sections: sectionList,
  };
};
